import Vue from 'vue'
import i18next from 'i18next'
import BrowserLanguageDetector from 'i18next-browser-languagedetector'
import VueI18Next from '@panter/vue-i18next'
import AsyncValidator from 'async-validator'
import _merge from 'lodash/merge'
import _get from 'lodash/get'
import moment from 'moment'

import elementLangFr from 'element-ui/lib/locale/lang/fr'
import elementLangEn from 'element-ui/lib/locale/lang/en'
import elementLangEs from 'element-ui/lib/locale/lang/es'
import ElementLocale from 'element-ui/lib/locale'

import generalLangFr from './i18n/fr-FR'
import dashboardLangFr from './i18n/fr-FR-dashboard'
import promptLangFr from './i18n/fr-FR-prompt'
import generalLangEn from './i18n/en-US'
import dashboardLangEn from './i18n/en-US-dashboard'
import promptLangEn from './i18n/en-US-prompt'
import generalLangEs from './i18n/es-ES'
import dashboardLangEs from './i18n/es-ES-dashboard'
import promptLangEs from './i18n/es-ES-prompt'
import generalLangMx from './i18n/es-MX'
import dashboardLangMx from './i18n/es-MX-dashboard'
import promptLangMx from './i18n/es-Mx-prompt'

const translationLangFr = _merge(generalLangFr, dashboardLangFr, promptLangFr)
const translationLangEn = _merge(generalLangEn, dashboardLangEn, promptLangEn)
const translationLangEs = _merge(generalLangEs, dashboardLangEs, promptLangEs)
const translationLangMx = _merge(generalLangMx, dashboardLangMx, promptLangMx)

Vue.use(VueI18Next)

const resources = {
  fr: { translation: _merge(translationLangFr, elementLangFr) },
  en: { translation: _merge(translationLangEn, elementLangEn) },
  es: { translation: _merge(translationLangEs, elementLangEs) },
  mx: { translation: _merge(translationLangMx, elementLangEs) }
}

i18next.use(new BrowserLanguageDetector()).init({
  detection: {
    order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain']
  },
  whitelist: Object.keys(resources),
  nonExplicitWhitelist: true,
  nsSeparator: '::',
  resources
})

const originalAsyncValidatorMessages = AsyncValidator.messages.clone()
ElementLocale.i18n((key, value) => i18next.t(key, value))

function setLanguage (language) {
  _merge(
    AsyncValidator.messages,
    originalAsyncValidatorMessages,
    _get(resources[language], 'translation.validator', {})
  )
  ElementLocale.use(language)
  moment.locale(language)
}

setLanguage(i18next.language)
i18next.on('languageChanged', setLanguage)

// Garde correctement i18nextLng dans localStorage si l'on récupère la langue sous cette forme par exemple: en-US
if (i18next.language.toLowerCase().includes('en')) {
  i18next.changeLanguage('en')
} else if (i18next.language.toLowerCase().includes('mx')) { // mx first because of es-MX
  i18next.changeLanguage('mx')
} else if (i18next.language.toLowerCase().includes('es')) {
  i18next.changeLanguage('es')
} else {
  i18next.changeLanguage('fr')
}

const i18n = new VueI18Next(i18next)
const $t = i18next.t.bind(i18next)

export { i18next, $t }
export default i18n
